import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import PuzzleGame from "./components/PuzzleGame";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { TouchBackend } from "react-dnd-touch-backend";
import "./styles/main.scss";
import DraggingPreview from "./components/DraggingPreview";

const backend = "ontouchstart" in window ? TouchBackend : HTML5Backend;
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <DndProvider backend={backend} options={{ enableMouseEvents: true }}>
    <PuzzleGame />
    <DraggingPreview />
  </DndProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
